/**
 * @hidden
 */
export var normalize = function normalize() {
  var settings = [];

  for (var _i = 0; _i < arguments.length; _i++) {
    settings[_i] = arguments[_i];
  }

  return Object.assign.apply(Object, [{
    allowUnsort: true,
    mode: 'single'
  }].concat(settings));
};